/**
 * Returns whether the value is null or undefined.
 * @param {*} v
 * @return {boolean}
 */
export function isAbsent(v) {
  return v === null || typeof v === 'undefined';
}
/**
 * Returns whether the value is not null and not undefined.
 * @param {*} v
 * @return {boolean}
 */
export function isPresent(v) {
  return !isAbsent(v);
}
